import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class Missionpick {
  constructor() {
    document
      .querySelectorAll('#conflict,#cyclone,#remote')
      .forEach(element => element.addEventListener('click', this.onStart.bind(this)));
  }
  init() {

    this.missionPicked = true;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }

  showScreen(data) {
    if (data['screenKey'] !== 'MissionPick') return false;

    document.querySelector('#missionselectionScr').classList.add('active');
    setTimeout(() => {
      document.querySelector('#missionselectionScr .container').classList.add('active1');
    }, 0);

  }

  onStart(events) {
    if (!this.missionPicked) return;
    this.missionPicked = false;

    const clickedId = events.currentTarget.id;
    Global.scenario = clickedId;

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: `360${Global.scenario}Click`,
      uniqID: Global.U_ID,
    });


    document.querySelector(`#${clickedId}`).classList.add('active');
    document.querySelector(`#${clickedId} div`).classList.add('active');


    document.querySelector('#missionselectionScr .container').classList.remove('active1');
    document.querySelector('#missionselectionScr .container').classList.add('active2');
    setTimeout(() => {
      document.querySelector('#missionselectionScr').classList.remove('active');
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'Assignment',
          },
        },
      });
    }, 700);



  }


}
